varying vec2 vUv;

void main()
{
    vUv = uv;
    // NDC 直書きで常に画面全体を覆う（カメラ・モデル行列を通さない）
    gl_Position = vec4(position.xy, 0.0, 1.0);
}
